import { useMemo } from 'react';
import { LifeSkillsLevel } from 'api';
import { FilterOption } from '@britishcouncil/react-admin';
import { useLifeSkillsLevelsForExaminerQuery } from 'store/dictionaries';
import { getLifeSkillsLevelName } from 'const/life-skills-level/lifeSkillsLevelHelpers';

export const NON_STANDARD_SHORT_CODE = 'Non-Standard';
export const PROCEDURES_SHORT_CODE = 'Procedures';
export const PROCEDURES_RATING_SHORT_CODE = 'Both Rating and Procedures';

export const useLifeSkillsLevelOptions = (
  examinerId: number,
  checkStatus: boolean = false
): {
  options: FilterOption<number>[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useLifeSkillsLevelsForExaminerQuery({ examinerId, checkStatus });

  const options = useMemo(
    () =>
      data?.map((item: LifeSkillsLevel) => ({
        text: getLifeSkillsLevelName(item),
        value: item,
      })) ?? [],
    [data]
  );

  return { options, isLoading };
};
